import { Loader2 } from 'lucide-react';
import { TransferTab } from '../phone/tabs/TransferTab';
import { usePhoneSettingsForm } from '../phone/PhoneSettingsContext';
import { SectionFrame } from './SectionFrame';

export function TransferSection() {
  const { form, setForm, loading } = usePhoneSettingsForm();
  return (
    <SectionFrame
      title="Anruf-Weiterleitung"
      description="Liste der Personen, an die die KI Anrufe weiterleiten darf, plus optionale Whitelist vertrauenswürdiger Anrufer."
    >
      {loading ? (
        <div className="flex h-32 items-center justify-center text-muted-foreground">
          <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Lade …
        </div>
      ) : (
        <TransferTab form={form} setForm={setForm} />
      )}
    </SectionFrame>
  );
}
